import V2Adapter from './v2';

export default class extends V2Adapter {
  namespace = 'a/visitors/api/v2/analytics';
}
